import { render, staticRenderFns } from "./TabLink.vue?vue&type=template&id=7aa8a94d&"
import script from "./TabLink.vue?vue&type=script&lang=ts&"
export * from "./TabLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports